import {
  useEffect,
  useState,
} from 'react'
import { useSearchBox } from 'react-instantsearch'
import { SearchInput } from '@sh24/ui-components'
import useDebouncedFn from '../../hooks/use-debounced-fn'

const SearchBox = ({
  placeholder,
  closeSearch,
  rounded,
  onClose,
}) => {
  const { query, refine, clear } = useSearchBox()
  const [inputValue, setInputValue] = useState(query)
  const debouncedRefine = useDebouncedFn(refine, 500)

  useEffect(() => {
    debouncedRefine(inputValue)
  }, [inputValue, debouncedRefine])

  const handleChange = (e) => {
    setInputValue(e.target.value)
  }

  const handleClear = () => {
    clear()
    setInputValue('')
    onClose?.()
  }

  return (
    <SearchInput
      onClose={handleClear}
      closeButtonAriaLabel={closeSearch}
      placeholder={placeholder}
      rounded={rounded}
      value={inputValue}
      onChange={handleChange}
    />
  )
}

export default SearchBox
